import InstallT1Connector from './InstallT1Connector';

export default InstallT1Connector;
